import { doccenHTTPRequest } from '../services/axios/httpRequest';

export const postIncommingChat = async () => {
  return doccenHTTPRequest.post(`/chat/countChat`, {});
};
